const TIME_AGO_CONSTANTS = {
	'seconds': 's',
	'minute': 'm',
	'minutes': 'm',
	'hour': 'h',
	'hours': 'h',
	'month': 'mo',
	'months': 'mo',
	'day': 'd',
	'days': 'd',
	'year': 'y',
	'years': 'y',
	'ago': ' ago',
}
const TIME_AGO_HELPER_CONSTANTS = {
	'about': '',
	"acerca de": '',
	'over': '',
	'terminada': '',
	'almost': '',
	'casi': '',
	'less':  '',
	'menos': '',
	'half': '',
	'mitad': '',
	'than':'',
	'a': '1',
	'de':'',
	'menos': '',
	'medio': '',
	'alrededor': '',
}
export const distanceInShortWords = (longWordDistance) => {
	let shortWordDistance = longWordDistance.toString().split(' ');
	
	for(let wordIndex in shortWordDistance) {
		const shortWord = TIME_AGO_CONSTANTS[shortWordDistance[wordIndex]];
		shortWordDistance[wordIndex] =  shortWord !== undefined ? shortWord : shortWordDistance[wordIndex];
	}
	return shortWordDistance.join('');
}
export const removeTimeAgoHelpers = (longWordDistance) => {
	let shortWordDistance = longWordDistance.toString().split(' ');
	
	for(let wordIndex in shortWordDistance){
		const shortWord = TIME_AGO_HELPER_CONSTANTS[shortWordDistance[wordIndex]];
		shortWordDistance[wordIndex] =  shortWord !== undefined ? shortWord : shortWordDistance[wordIndex];
	}
	return shortWordDistance.join(' ');
}